import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { cleanupZombieServiceWorkers } from './shared/lib/cleanupZombieSW'
import './styles/app.css'

// Fire-and-forget: nao bloqueia o render, mas limpa SWs de deploys antigos
// que estejam interceptando requests e causando travamentos.
cleanupZombieServiceWorkers()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
